function patientData() {
  return {
    practitionerID: null,
    patients: [],
    filteredPatientsData: [],
    searchQuery: '',
    previousSearchQuery: '',
    sortBy: 'name',
    sortOrder: 'asc',
    currentPage: 1,
    itemsPerPage: 1,
    showPatientForm: false,
    showPatientFormSuccess: false,
    successTimeoutId: null,
    termsPatientForm: false,
    pagesToShow: 5,
    addUserIDinDJ: '',
    isAwaitingResponse: false,
    deleteScriptIDinDJ:'',
    getNewUserScriptIDinDJ:'',
    notification: {
      message: '',
      status: 'ok',
    },
    isUrlSuccessParam: false,

    normalizeDate(dateString) {
      const isFormattedDate = /^\d{2}\/\d{2}\/\d{4}$/.test(dateString);
      if (isFormattedDate) {
        return dateString;
      }
      return this.formatDate(dateString);
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },

    removeURLParam(param) {
      const url = new URL(window.location);
      const urlParams = new URLSearchParams(url.search);

      if (urlParams.has(param)) {
        urlParams.delete(param);
        window.history.replaceState(
          {},
          document.title,
          `${url.pathname}?${urlParams}`
        );

        this.isUrlSuccessParam = false;
      }
    },

    isURLParamsSuccess() {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('patient_success')) {
        this.showPatientForm = true;
        this.showPatientFormSuccess = true;
        this.isUrlSuccessParam = true;

        this.successTimeoutId = setTimeout(() => {
          if (this.successTimeoutId) {
            this.showPatientForm = false;
            this.showPatientFormSuccess = false;

            this.getNewUser();

            this.removeURLParam('patient_success');

            this.successTimeoutId = null;
          }
        }, 10000);
      }
    },

    init(practitionerID, itemsPerPage,  deleteScriptIDinDJ, getNewUserScriptIDinDJ, addUserIDinDJ) {
      this.practitionerID = `gid://shopify/Customer/${practitionerID}`;
      this.itemsPerPage = itemsPerPage ? itemsPerPage : 6;
      this.addUserIDinDJ = addUserIDinDJ;
      this.deleteScriptIDinDJ = deleteScriptIDinDJ;
      this.getNewUserScriptIDinDJ = getNewUserScriptIDinDJ;

      const patientsScript = document.getElementById('PATIENTS_JSON');
      if (patientsScript) {
        this.patients = JSON.parse(patientsScript.textContent);
        this.patients.forEach((patient) => {
          patient.register_date = this.normalizeDate(patient.register_date);
        });
      }

      this.isURLParamsSuccess();
    },

    formatSortBy() {
      if (this.sortBy === 'name') {
        return 'Alphabétique';
      } else if (this.sortBy === 'register_date') {
        return 'Date';
      }
      return 'Unknown';
    },

    formatSortOrder() {
      if (this.sortOrder === 'asc') {
        return this.sortBy === 'name' ? 'A-Z' : 'Ancien-Nouveau';
      } else if (this.sortOrder === 'desc') {
        return this.sortBy === 'name' ? 'Z-A' : 'Nouveau-Ancien';
      }
      return 'Unknown';
    },

    get totalPages() {
      return Math.ceil(this.filteredPatientsData.length / this.itemsPerPage);
    },

    get filteredPatients() {
      let filtered = this.patients;
    
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        filtered = filtered.filter((patient) =>
          patient.name.toLowerCase().includes(query) ||
          patient.email?.toLowerCase().includes(query)
        );
      }
    
      filtered.sort((a, b) => {
        let fieldA, fieldB;
    
        if (this.sortBy === 'register_date') {
          fieldA = new Date(a[this.sortBy].split('/').reverse().join('-'));
          fieldB = new Date(b[this.sortBy].split('/').reverse().join('-'));
        } else {
          fieldA = a[this.sortBy]?.toLowerCase() || '';
          fieldB = b[this.sortBy]?.toLowerCase() || '';
        }
    
        if (this.sortOrder === 'asc') {
          return fieldA < fieldB ? -1 : fieldA > fieldB ? 1 : 0;
        } else {
          return fieldA > fieldB ? -1 : fieldA < fieldB ? 1 : 0;
        }
      });
    
      if (this.searchQuery !== this.previousSearchQuery) {
        this.changePage(1);
        this.previousSearchQuery = this.searchQuery;
      }
    
      this.filteredPatientsData = filtered;
    
      return this.filteredPatientsData;
    },

    get paginatedPatients() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredPatients.slice(start, start + this.itemsPerPage);
    },

    get visiblePages() {
      const half = Math.floor(this.pagesToShow / 2);
      let start = this.currentPage - half;
      let end = this.currentPage + half;

      if (start < 1) {
        start = 1;
        end = Math.min(this.pagesToShow, this.totalPages);
      }

      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(1, this.totalPages - this.pagesToShow + 1);
      }

      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },

    sort(field, order = null) {
      if (order) {
        this.sortOrder = order;
      } else {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      }

      this.sortBy = field;
    },

    clearSuccessTimeout() {
      if (this.successTimeoutId) {
        clearTimeout(this.successTimeoutId);
        this.successTimeoutId = null;
      }
    },

    closePatientForm() {
      this.getNewUser();

      this.clearSuccessTimeout();

      if (this.showPatientForm) {
        this.showPatientForm = false;
      }

      if (this.showPatientFormSuccess) {
        this.showPatientFormSuccess = false;
      }
    },

    openPatientForm() {
      this.clearSuccessTimeout();

      this.showPatientForm = true;
    },

    showNotification(notification, timeout = 5000) {
      this.notification = { ...notification };

      setTimeout(() => {
        this.clearNotification();
      }, timeout);
    },

    clearNotification() {
      this.notification = {
        message: '',
        status: 'ok',
      };
    },

    async getNewUser() {
      if (this.isUrlSuccessParam) {
        this.isAwaitingResponse = true;

        const taskId = this.getNewUserScriptIDinDJ;

        const url = `/apps/datajet/task/${taskId}`;

        const data = {
          store: true,
          invited_id: this.practitionerID,
        };

        await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then((res_data) => {
            this.isAwaitingResponse = false;

            if (res_data.status == 'ok') {
              const { message, data, status } = res_data;

              this.removeURLParam('patient_success');

              this.showNotification(
                {
                  message,
                  status,
                },
                10000
              );

              if (data) {
                this.patients = JSON.parse(data);
                this.patients.forEach((patient) => {
                  patient.register_date = this.normalizeDate(
                    patient.register_date
                  );
                });
              }
            }

            if (res_data.status == 'warning' || res_data.status == 'error') {
              const { message, status } = res_data;

              this.showNotification(
                {
                  message,
                  status,
                },
                10000
              );
            }
          })
          .catch((error) => {
            this.isAwaitingResponse = false;
            this.showNotification({
              message:
                'Something went wrong. More information in the developer console',
              status: 'error',
            });
            console.error('Error:', error);
          });
      }
    },

    async removePatient(patientID, patientEmail) {
      this.isAwaitingResponse = true;

      const taskId = this.deleteScriptIDinDJ;
      const url = `/apps/datajet/task/${taskId}`;

      const data = {
        store: true,
        customer_id: patientID,
        customer_email: patientEmail,
        invited_id: this.practitionerID,
      };

      await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((res_data) => {
          this.isAwaitingResponse = false;

          if (res_data.status == 'ok') {
            const { message, data, status } = res_data;

            this.showNotification({
              message,
              status,
            });

            if (data) {
              this.patients = JSON.parse(data);
              this.patients.forEach((patient) => {
                patient.register_date = this.normalizeDate(
                  patient.register_date
                );
              });
            }
          }

          if (res_data.status == 'warning' || res_data.status == 'error') {
            const { message, status } = res_data;

            this.showNotification({
              message,
              status,
            });
          }
        })
        .catch((error) => {
          this.isAwaitingResponse = false;
          this.showNotification({
            message:
              'Something went wrong. More information in the developer console',
            status: 'error',
          });
          console.error('Error:', error);
        });

      console.log('remove patient');
    },

    async validateAndAddPatient() {
      const firstNameInput = document.querySelector('#first_name_custom');
      const emailInput = document.querySelector('#patient_email');

      if (!firstNameInput.value.trim()) {
        firstNameInput.parentElement.classList.add('error');
        console.log('First name cannot be empty');

        return;
      } else {
        firstNameInput.parentElement.classList.remove('error');
      }

      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.test(emailInput.value)) {
        console.log('Please enter a valid email address');
        emailInput.parentElement.classList.add('error');
        return;
      } else {
        emailInput.parentElement.classList.remove('error');
      }

      await this.addPatient();
    },

    getInviteDate() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const hours = String(currentDate.getHours()).padStart(2, '0');
      const minutes = String(currentDate.getMinutes()).padStart(2, '0');
      const seconds = String(currentDate.getSeconds()).padStart(2, '0');

      const timezoneOffset = currentDate.getTimezoneOffset();
      const timezoneHours = String(
        Math.floor(Math.abs(timezoneOffset) / 60)
      ).padStart(2, '0');
      const timezoneMinutes = String(Math.abs(timezoneOffset) % 60).padStart(
        2,
        '0'
      );
      const timezoneSign = timezoneOffset > 0 ? '-' : '+';

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${timezoneSign}${timezoneHours}:${timezoneMinutes}`;
    },

    async addPatient() {
      this.isAwaitingResponse = true;

      const taskId = this.addUserIDinDJ;

      const url = `/apps/datajet/task/${taskId}`;

      const patient_email = document.querySelector('#patient_email');
      const patient_name = document.querySelector('#first_name_custom');

      const formattedDate = this.getInviteDate();

      const data = {
        store: true,
        customer_email: patient_email.value,
        customer_name: patient_name.value,
        register_date: formattedDate,
        invited_id: this.practitionerID,
      };

      await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((res_data) => {
          this.isAwaitingResponse = false;

          if (res_data.status == 'ok') {
            const { message, data, status } = res_data;

            this.showNotification({
              message,
              status,
            });

            if (data) {
              this.patients = JSON.parse(data);
              this.patients.forEach((patient) => {
                patient.register_date = this.normalizeDate(
                  patient.register_date
                );
              });
            }

            const shadowHost = document.querySelector('#app-embed');
            const shadowRoot = shadowHost.shadowRoot;
            const submitBtn = shadowRoot.querySelector(
              '[data-testid="btn-form-submit"]'
            );

              submitBtn.click();

              const popup = document.querySelector('.patients__content-popup')
              const popupCloseBtn = document.querySelector('.popup__close-btn')
              const formContent = document.querySelector('.form__cotnent')
              const formSuccess = document.querySelector('.form__success')
              formContent.classList.add('hidden');
              formSuccess.style.display = 'flex';
              popup.querySelector('.popup__cotnent-body').classList.add('success-form')
              popup.classList.add('show');

              popupCloseBtn.addEventListener('click', () => {
                formContent.classList.remove('hidden');
                formSuccess.style.display = 'none';
                popup.querySelector('.popup__cotnent-body').classList.remove('success-form')
                popup.classList.remove('show');
                popup.querySelector('#first_name_custom').value = '';
                popup.querySelector('#patient_email').value = '';
                popup.querySelector('#patient_terms').checked = false;
                this.termsPatientForm = false;
              })
            }

          if (res_data.status == 'warning' || res_data.status == 'error') {
            const { message, status } = res_data;
            this.showNotification({
              message,
              status,
            });
          }
        })
        .catch((error) => {
          this.isAwaitingResponse = false;
          this.showNotification({
            message:
              'Something went wrong. More information in the developer console',
            status: 'error',
          });
          console.error('Error:', error);
        });
    },
  };
}
